import Vue from 'vue'
import VueI18n from 'vue-i18n'
import translations from './translations'
import nl from './../../wwwroot/assets/lang/lang-en.json'
import $ from 'jquery'

Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: {nl}
})

translations.getLanguages().then(sysLangs => {
    let defaultLang
    sysLangs.forEach(element => {
        if(element.longTitle === 'English'){
            defaultLang = element
        }
    });
    funcs.loadTranslations(defaultLang)
    i18n.locale = defaultLang.title
})

const funcs = {
    loadTranslations : function(lang) {
        let msgs
        $.getJSON(lang.translationsPath, json => {
            msgs = json
        }).then(() => {
            i18n.setLocaleMessage(lang.title, msgs)
        })
    }
}

export { i18n, funcs }